export default "__VITE_ASSET__BfkWKqiK__"